import withLoader from "UIComponents/GqlWithLoader";
import comp from "./StudentList";
export default withLoader(comp);
